/**
 * Layout: Captcha
 * -----------------------------------------------------------------------------
 * Setup captcha page.
 *
 */
export default () => {

  /**
   * Initialise captcha.
   */
  function init() {
    if (window.cnvs.page.type === 'captcha') {
      const footer = document.getElementById('shopify-section-site-footer')
      const newsletterSection = document.querySelector('[data-component-handle="newsletter-form"]')

      footer.before(newsletterSection)
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
